import React from 'react';

/**
 * A2P 10DLC brand-approval banner — RETIRED.
 *
 * The A2P registration flow was legacy-provider-specific. Mantle has moved to an
 * iMessage-first provider (Sendblue) which does not require A2P 10DLC.
 * Component kept as a no-op so any existing imports keep compiling.
 */
export default function A2pApprovalBanner() {
  return null;
}
